<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
            <el-form-item label="提货单号:" prop="billNo">
              <el-input placeholder="" v-model="searchFrom.billNo"></el-input>
            </el-form-item>
            <!-- <el-form-item label="提单状态:" prop="status">
                <el-select v-model="searchFrom.status" placeholder="全部">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="处理中" value="1" ></el-option>
                  <el-option  label="已完成" value="2" ></el-option>
                  <el-option  label="已作废" value="3" ></el-option>
                </el-select>
              </el-form-item> -->
            <el-form-item label="外部提单号:" prop="outBillNo">
              <el-input placeholder="" v-model="searchFrom.outBillNo"></el-input>
            </el-form-item>
            <el-form-item label="提单状态:" prop="status">
              <el-select v-model="searchFrom.status" placeholder="请选择">
                <el-option label="请选择" value=""></el-option>
                <el-option label="审批中" value="1001"></el-option>
                <el-option label="审批驳回" value="1002"></el-option>
                <el-option label="找车中" value="1005"></el-option>
                <el-option label="待处理" value="1011"></el-option>
                <el-option label="处理中" value="1012"></el-option>
                <el-option label="己完成" value="1021"></el-option>
                <el-option label="己作废" value="1022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
              <el-input placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="控货方:" prop="oneCustomerName" v-if="tableArr[0]">
              <el-input placeholder="" v-model="searchFrom.oneCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="车辆号牌:" prop="vhcNo">
              <el-input placeholder="" v-model="searchFrom.vhcNo"></el-input>
            </el-form-item>
            <el-form-item label="是否扣车:" prop="isCarHold" v-if="tableArr[2]">
              <el-select v-model="searchFrom.isCarHold" placeholder="全部">
                <el-option label="全部" value=""></el-option>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker v-model="searchFrom.createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change='selectGoods'  class="tableComent" @row-click="handleRowClick" style="width: 100%" height="100%" center border v-if="tableArr.length>0">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="170">
          <template slot-scope="scope">
            <div>
              <el-button type="text" v-if="btnFlg[0] && ((scope.row.status==1012||scope.row.status==1011) && scope.row.isCarHold==1)" size="mini" @click="fangXing(scope.row)">车辆放行</el-button>
              <el-button type="text" size="mini" v-if="scope.row.status==1002&&btnFlg[1]" @click="delFn(scope.row)">删除</el-button>
              <!-- <el-button type="text" size="mini"  v-if="(scope.row.status<1021&&scope.row.status!=1002)&&btnFlg[2]"  @click="rencheFn(scope.row)">人车</el-button> -->
              <el-button type="text" size="mini" v-if="(scope.row.status==1011||scope.row.status==1012||scope.row.status==1021)&&btnFlg[2]" @click="rencheFn(scope.row)">人车</el-button>
              <el-button type="text" size="mini" v-if="((scope.row.status==1005&&scope.row.findCarFlag==1)||scope.row.status==1011)&&btnFlg[3]" @click="zuofeiFn(scope.row)">作废</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="billNo" min-width="220" :formatter="emptyFn" label="提货单号">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.billNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="outBillNo" min-width="200" :formatter="emptyFn" label="外部提单号"></el-table-column>
        <el-table-column prop="ownerCustomerName" min-width="200" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
        <el-table-column prop="oneCustomerName" min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
        <el-table-column label="提货函" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="lookFn(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column property="status" label="提单状态" min-width="100">
          <template scope="scope">
            <div>
           {{[ "处理中", "已完成", "已作废"][scope.row.status-1]}}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column width="120" prop="status" :formatter="statusFormat" label="提单状态"></el-table-column>
        <el-table-column prop="plan" min-width="180" :formatter="emptyFn" label="提货量(吨/件)">
          <template scope="scope">
            <div>
              {{scope.row.planWeight}} / {{scope.row.planNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="actual" width="180" :formatter="emptyFn" label="实提量(吨/件)">
          <template scope="scope">
            <div>
              {{scope.row.actualWeight}} / {{scope.row.actualNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="isCarHold" label="是否扣车" min-width="100" v-if="tableArr[2]">
          <template scope="scope">
            <div>
              {{[ "是", "否"][scope.row.isCarHold-1]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="validityTime" min-width="200" v-if="tableArr[3]" :formatter="dateTimeFormat" label="有效期至"></el-table-column>
        <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
        <el-table-column property="findCarFlag" width="150" label="是否找车提单">
          <template scope="scope">
            <span v-if="scope.row.findCarFlag == 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column property="demandType" width="120" label="找车类型">
          <template scope="scope">
            <span v-if="scope.row.demandType == 1">竞价</span>
            <span v-else-if="scope.row.demandType == 2">抢单</span>
            <span v-else-if="scope.row.demandType == 3">指派</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="200" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[50,100,200,1000]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 人车 -->
    <renChe :row-data="addFrom" v-if="rencheFlag" @destroy="destroy"></renChe>
    <!-- 作废-->
    <el-dialog title="作废" :visible.sync="dialogZF" width="460px" :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <el-form :inline="true" :rules="rules" :model="zuofeiFrom" ref="zuofeiFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
          <el-form-item label="作废原因:" prop="reason" class="miaoshu">
            <el-input type="textarea" :rows="3" placeholder="" maxlength="100" v-model="zuofeiFrom.reason"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogZF = false">取 消</el-button>
        <el-button type="primary" @click="ZFsave()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 提货函记录 -->
    <el-dialog title="提货函记录" :close-on-click-modal="false" :close-on-press-escape="false" class="detail" @close="closeDialog" :modal="false" :visible.sync="THdialog" width="700px" center>
      <div>
        <el-table :data="THlist" bordersize="mini" style="width: 100%" height="400" center border>
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货函" width="120">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="lookClick(scope.row)">查看</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operationUserName" min-width="150" :formatter="emptyFn" label="操作人"></el-table-column>
          <el-table-column prop="createTime" min-width="200" :formatter="dateTimeFormat" label="操作时间"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="THdialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn, getAttribute, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getSBillFileUrl, sFileChangeRecordList, cancelFindCarTypeEmptyBill } from '@/api/soc-stock'
import { SVBlist, SVBVehicleRelease, findExtAttritude, SVBdelete, cancelEmptyBill, getOrganizationNameList } from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import renChe from '@/views/soc-stock-cosco/takeGoodsBill/renChe.vue'
export default {
  components: {
    renChe
  },
  data () {
    return {
      THlist: [],
      THdialog: false,
      tableArr: [],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {},
      zuofeiFrom: {},
      dialogZF: false,
      total: 0,
      loading: false,
      goodTypes: [],
      isDisable: false,
      rencheFlag: false,
      rules: {
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }]
      },
      btnFlg: [],
      btnIdArr: ['00UP003B001', '00UP003B002', '00UP003B003', '00UP003B004'],
      janFaFlag: null,
      findCarFlag: '',
      billNo: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ZYtakeGoodsBill')
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName,ARRisCarHold,ARRvalidityTime,ARRdriverIdentityNo')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      // let orgName = this.warehouseList[0].relTenantName
      // if (orgName.indexOf('建发钢铁物流') != -1 || orgName.indexOf('首线联合') != -1 || orgName.indexOf('建发') != -1) {
      //   this.janFaFlag = 1
      // }
      getAttributeA('ARRisSelfWarehouse', this.warehouseList[0].relTenantCode).then(res => {
        console.log(res)
        if (res[0] == 3) { // 是建发库
          this.janFaFlag = 1
        }
        this.getList(this.searchFrom)
      })
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          let orgName = this.warehouseList[0].relTenantName
          if (orgName.indexOf('建发钢铁物流') != -1 || orgName.indexOf('首线联合') != -1 || orgName.indexOf('建发') != -1) {
            this.janFaFlag = 1
          }
        }
      })
      this.getList(this.searchFrom)
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    zuofeiFn (row) {
      this.dialogZF = true
      this.zuofeiFrom.id = row.id
      this.findCarFlag = row.findCarFlag
      this.billNo = row.billNo
    },
    ZFsave () {
      this.$refs.zuofeiFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.findCarFlag == 1) {
            cancelFindCarTypeEmptyBill({
              billNo: this.billNo,
              abandonedReason: this.zuofeiFrom.reason
            }).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.dialogZF = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            cancelEmptyBill(this.zuofeiFrom).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.dialogZF = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 人车
    rencheFn (row) {
      if (row.findCarFlag == 1) {
        this.addFrom.zhaoCheTD = false
      } else if (row.findCarFlag != 1) {
        console.log(row.findCarFlag)
        this.addFrom.zhaoCheTD = true
      }
      this.addFrom.id = row.id
      this.addFrom.zhanshiFlag = [this.tableArr[4]]
      this.addFrom.janFaFlag = this.janFaFlag
      this.addFrom.status = row.status
      this.rencheFlag = true
    },
    destroy () {
      this.rencheFlag = false
    },
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = this.searchFrom
      form.oneCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      form.isCarHoldFlag = this.tableArr[2]
      form.validityTimeFlag = this.tableArr[3]
      exportExcel(
        this.global.stockName + '/sVirtualBill/virtualBillExport',
        form,
        '提货单据'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查看
    // lookFN (row) {
    //   getCVehicleInfoListByDriverId({ driverId: row.id }).then(res => {
    //     this.dialogVisible = true
    //     this.carList = res
    //   })
    // },
    // 查看提货函
    // lookFn (row) {
    //   debugger
    //   if (row.fileUrl) {
    //     let formData = new FormData()
    //     formData.append('url', row.fileUrl)
    //     getSBillFileUrl(formData).then(res => {
    //       this.$router.push({
    //         name: 'Pdf',
    //         query: { path: res }
    //       })
    //     })
    //   } else {
    //     this.$alert('暂无提货函', '系统提示')
    //   }
    // },
    // 查看提货函记录（改）
    lookFn (row) {
      if (row.fileUrl) {
        sFileChangeRecordList({ id: row.id }).then(res => {
          if (res.length == 0 || res.length == 1) {
            let formData = new FormData()
            formData.append('url', row.fileUrl)
            getSBillFileUrl(formData).then(res => {
              this.$router.push({
                name: 'Pdf',
                query: { path: res }
              })
            })
          } else {
            this.THdialog = true
            this.THlist = res
          }
        })
      } else {
        this.$alert('暂无提货函', '系统提示')
      }
    },
    // 查看提货函
    lookClick (row) {
      if (row.fileUrl) {
        let formData = new FormData()
        formData.append('url', row.fileUrl)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      }
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'ZYtakeGoodsBillDetails', query: { id: row.id } })
    },
    // 查选
    // searchFn () {
    //   if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
    //   this.getList(this.searchFrom)
    // },
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      SVBlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      if (localStorage.getItem('isCutCrm3') == 1) {
        this.$set(this.searchFrom, 'organizationId', localStorage.getItem('createTenantCode'))
      }
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        // let formData = new FormData()
        // formData.append('id', row.id)
        SVBdelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 车辆放行
    fangXing (row) {
      this.$confirm('是否执行车辆放行操作?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        SVBVehicleRelease({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '放行成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.zuofeiFrom = {}
      this.$refs.table.clearSelection()
      this.flag = false
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '审批中'
        case 1002:
          return '审批驳回'
        case 1011:
          return '待处理'
        case 1012:
          return '处理中'
        case 1021:
          return '已完成'
        case 1022:
          return '已作废'
        case 1005:
          return '找车中'
      }
    }
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    if (from.path !== '/pdf') {
      next(vm => {
        vm.reload()
      })
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/pdf') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor {
  width: 350px !important;
}
.imgBox {
  display: flex;
  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }
}
/deep/ .checkboxBox {
  display: flex;
  label {
    flex-shrink: 0;
  }
  .el-checkbox-group {
    width: 250px;
  }
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
